import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchItems = async (options, cancelToken) => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options, cancelToken });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const fetchTypeCategories = async options => {
  const url = apiConstants.typecategory;
  return await apiGet(url, { params: options });
};

const fetchFrames = async options => {
  const url = apiConstants.frame;
  return await apiGet(url, { params: options });
};

const fetchNumberRanges = async options => {
  const url = apiConstants.numberrange;
  return await apiGet(url, { params: options });
};

const fetchWallConnections = async options => {
  const url = apiConstants.wallconnection;
  return await apiGet(url, { params: options });
};

const fetchCountries = async options => {
  const url = apiConstants.countries;
  return await apiGet(url, { params: options });
};

const fetchLabeltypes = async options => {
  const url = apiConstants.labeltypes;
  return await apiGet(url, { params: options });
};

const fetchUdTables = async options => {
  const url = apiConstants.udtable;
  return await apiGet(url, { params: options });
};

const fetchRuleGroups = async options => {
  const url = apiConstants.rulegroup;
  return await apiGet(url, { params: options });
};

const fetchArticleItems = async options => {
  const url = apiConstants.item;
  return await apiGet(url, { params: options });
};

const fetchArticleItemCategories = async options => {
  const url = apiConstants.itemcategory;
  return await apiGet(url, { params: options });
};

const fetchComponent = async id => {
  const url = apiConstants.component;
  return await apiGet(url + "/" + id);
};

const saveComponent = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.component + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.component;
    return await apiPost(url, { ...data }, validator);
  }
};

const deleteComponent = async id => {
  const url = apiConstants.component;
  return await apiDelete(url + "/" + id);
};

const saveExtract = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.extract + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.extract;
    return await apiPost(url, { ...data }, validator);
  }
};

const deleteExtract = async id => {
  const url = apiConstants.extract;
  return await apiDelete(url + "/" + id);
};

const fetchTags = async options => {
  const url = apiConstants.tags;
  return await apiGet(url, { params: options });
};

const fetchEdgeSpacers = async options => {
  const url = apiConstants.edgespacer;
  return await apiGet(url, { params: options });
};

const duplicateItem = async id => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id + "/duplicate");
};

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  fetchTypeCategories,
  fetchFrames,
  fetchNumberRanges,
  fetchWallConnections,
  fetchUdTables,
  fetchRuleGroups,
  fetchArticleItems,
  saveComponent,
  deleteComponent,
  saveExtract,
  deleteExtract,
  fetchComponent,
  fetchTags,
  duplicateItem,
  fetchArticleItemCategories,
  fetchEdgeSpacers,
  fetchCountries,
  fetchLabeltypes
};
